<script setup>
import { ref, computed, onMounted } from "vue";
import { useRouter, useRoute } from 'vue-router';
import { translate, changeLang } from "../assets/translations.js";

const router = useRouter();
const route = useRoute();
const isDropdownOpen = ref(false);

const Image = computed(() => {
  return localStorage.getItem("lang") === "es" ? "/img/british_flag.png" : "/img/spain_flag.jpeg";
});

const actionLang = () => {
  let lang = localStorage.getItem("lang") === "es" ? "en" : "es";
  localStorage.clear();
  changeLang(lang);
};

const toggleDropdown = () => {
  if (route.path !== '/') {
    router.push('/');
    localStorage.setItem('openDropdown', 'true');
  } else {
    isDropdownOpen.value = !isDropdownOpen.value;
  }
};

const scrollToSection = (id) => {
  isDropdownOpen.value = false;
  const navMenu = document.getElementById('nav-menu');

  if (route.path !== '/') {
    localStorage.setItem('scrollTo', id);
    router.push('/');
  } else {
    const section = document.getElementById(id);
    section?.scrollIntoView({ behavior: 'smooth' });

    // Cierra el menú solo después del scroll (en mobile)
    navMenu.classList.remove('show-menu');
  }
};

onMounted(() => {
  const navToggle = document.getElementById('nav-toggle');
  const navClose = document.getElementById('nav-close');
  const navMenu = document.getElementById('nav-menu');

  if (navToggle && navClose && navMenu) {
    navToggle.addEventListener('click', () => {
      navMenu.classList.add('show-menu');
    });

    navClose.addEventListener('click', () => {
      navMenu.classList.remove('show-menu');
    });
  }

  const themeButton = document.getElementById('theme-button');
  if (themeButton) {
    themeButton.addEventListener('click', () => {
      document.body.classList.toggle('dark-theme');
    });
  }

  const scrollHeader = () => {
    const header = document.getElementById('header');
    window.scrollY >= 50 ? header.classList.add('bg-header') : header.classList.remove('bg-header');
  };
  window.addEventListener('scroll', scrollHeader);

  // Cierra el menú solo si se hace clic fuera (en mobile)
  document.addEventListener('click', (e) => {
    const navMenu = document.getElementById('nav-menu');
    const navToggle = document.getElementById('nav-toggle');
    const dropdownToggle = e.target.closest('.dropdown-toggle');
    const insideMenu = e.target.closest('#nav-menu');

    if (!insideMenu && !navToggle.contains(e.target) && !dropdownToggle) {
      navMenu.classList.remove('show-menu');
      isDropdownOpen.value = false;
    }
  });

  // Abre dropdown si el usuario viene de otra ruta y lo pidió
  if (localStorage.getItem('openDropdown') === 'true') {
    isDropdownOpen.value = true;
    localStorage.removeItem('openDropdown');
  }
});
</script>


<template>
  <header class="header" id="header">
    <nav class="nav container">
      <router-link to="/" class="nav__logo">
        Resi Corporation
      </router-link>
      <div class="nav__menu" id="nav-menu">
        <ul class="nav__list grid">
          <!-- Dropdown Inicio -->
          <li class="nav__item dropdown">
            <button class="nav__link dropdown-toggle" @click="toggleDropdown">
              <i class="ri-home-office-line"></i> {{ translate("inicio").name }}
              <i class="ri-arrow-down-s-line dropdown-arrow" :class="{ rotate: isDropdownOpen }"></i>
            </button>
            <ul v-show="isDropdownOpen" class="dropdown-menu">
              <li>
                <a href="#" @click.prevent="scrollToSection('skills')">     {{ translate("desarrollo").habilidades }}            
                </a>
              </li>
              <li>
                <a href="#" @click.prevent="scrollToSection('services')">   {{ translate("servicios").name }}
                </a>
              </li>
              <li>
                <a href="#" @click.prevent="scrollToSection('projects')">   {{ translate("proyectos").nameProyecto }}
                </a>
              </li>
              <li>
                <a href="#" @click.prevent="scrollToSection('testimonials')">
                  {{ translate("testimonials").name }}
                </a>
              </li>
              <li><a href="#" @click.prevent="scrollToSection('contact')">{{ translate("contacto").name }}</a></li>
            </ul>
          </li>

          <!-- Otros views -->
          <li class="nav__item">
            <router-link to="/associates" class="nav__link view-link" aria-label="Servicios Asociados">
              <i class="ri-map-pin-user-fill"></i> 
              {{ translate("inicio").associates }}
            </router-link>
          </li>

          <li class="nav__item">
            <router-link to="/blog" class="nav__link view-link" aria-label="Artículos Páginas web">
              <i class="ri-newspaper-line"></i> 
              {{ translate("inicio").blog }}
            </router-link>
          </li>
        </ul>

        <div class="nav__close" id="nav-close">
          <i class="ri-close-line"></i>
        </div>
      </div>

      <div class="nav__buttons">
        <div id="flag" @click="actionLang">
          <img :src="Image" alt="Cambio de idioma" title="Cambio de idioma">
        </div>
        <i class="ri-moon-line change-theme" id="theme-button"></i>
        <div class="nav__toggle" id="nav-toggle">
          <i class="ri-menu-4-line"></i>
        </div>
      </div>
    </nav>
  </header>
</template>

<style scoped>
#flag {
  width: 20px;
  height: 20px;
  border-radius: 100%;
  cursor: pointer;
}

#flag > img {
  width: 100%;
  height: 100%;
  border-radius: 100%;
}

/* Dropdown */
.dropdown {
  position: relative;
}

.dropdown-toggle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  background: none;
  border: none;
  color: inherit;
  font: inherit;
  cursor: pointer;
  transition: background 0.3s;
}

.dropdown-arrow {
  margin-left: 0.5rem;
  transition: transform 0.3s ease;
}
.dropdown-arrow.rotate {
  transform: rotate(180deg);
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  background-color: var(--body-color);
  box-shadow: 0 8px 16px rgba(0,0,0,0.1);
  border-radius: 0.5rem;
  z-index: 1000;
  min-width: 200px;
  padding: 0.5rem 0;
}

.dropdown-menu li a {
  display: block;
  padding: 0.5rem 1rem;
  color: var(--title-color);
  transition: background 0.2s;
}
.dropdown-menu li a:hover {
  background-color: var(--first-color-light);
}
</style>
